<template>
  <!-- ======= Portfolio Details Section ======= -->
  <section id="portfolio-details" class="portfolio-details">
    <div class="container">
      <div class="portfolio-details-container">
        <carousel :items="1" :nav="false">
          <div
            :key="img.id"
            v-for="img in element.images"
            class="portfolio-details-carousel"
          >
            <img :src="img" class="img-fluid carousel-img" alt="" />
          </div>
        </carousel>
        <div class="portfolio-info">
          <h3>Project information</h3>
          <ul>
            <li>{{ element.title }}</li>
            <li><strong>Category</strong>: {{ element.type | format() }}</li>
            <li>
              <strong>Project URL</strong>:
              <a :href="element.url">{{ element.url.slice(0, 10) }}...</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="portfolio-description">
        <h5>Portfolio Description</h5>
        <h6>{{ element.description }}</h6>
      </div>
    </div>
  </section>
  <!-- End Portfolio Details Section -->
</template>
<script>
import carousel from "vue-owl-carousel";

export default {
  name: "PortfolioDetails",
  props: ["element"],
  components: {
    carousel
  },
  filters: {
    format(text) {
      if (text == "UI") {
        return "UI/UX Design";
      } else if (text == "data") {
        return "Data Analysis";
      } else if (text == "web") {
        return "Web Development";
      } else if (text == "wordpress") {
        return "WordPress";
      } else {
        return "";
      }
    }
  }
};
</script>
<style scoped>
.portfolio-description h5 {
  margin-top: 20px;
}
</style>
